export default __webpack_public_path__ + "static/media/vili_m.650c5e56.jpg";